import React from 'react';
import BaseInputFile from '../../sisu/form/BaseInputFile.sisu';

const NeoInputFile = React.forwardRef((props, ref) => {
  return <BaseInputFile {...props} ref={ref} />;
});

export default NeoInputFile;
